import { useCallback, useEffect, useState } from "react";
import "./Login.css";
import axios from "axios";
import { Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { urlBase } from "../../Constante/Url";
import Logo from "../../assets/images/Logo colorida.png";
import { userRequest } from "../../userRequest";
import { Link, useNavigate } from "react-router-dom";
import { useUserContext } from "../../contexts/usersContext";
import { ModalOtp } from "./modalOtp";
import { loginRequest } from "./loginRequest";

const Login = () => {
  const { login } = useUserContext();

  const [otp, setOtp] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorOtp, setErrorOtp] = useState("");
  const [valuesForm, setValuesForm] = useState({
    email: "",
    password: "",
  });
  const [preAuthToken, setPreAuthToken] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [openModalOtp, setOpenModalOtp] = useState(false);
  const [loadingRequestCode, setLoadingRequestCode] = useState(false);

  const navigation = useNavigate();

  const loginOtp = useCallback(async () => {
    if (!otp.trim()) {
      setErrorOtp("Informe o código de autenticação.");
      return;
    }

    setLoadingOtp(true);
    setErrorOtp("");

    try {
      const payload = {
        ...valuesForm,
        otp_token: otp,
        pre_auth_token: preAuthToken,
      };

      const response = await axios.post(`${urlBase}login/`, payload, {
        validateStatus: (status) => status < 500,
      });

      if (response.status === 200) {
        login(response.data.access, null);
        const responseUser = await userRequest.getUser(response.data.user_id);
        if (responseUser.status === 200 || responseUser.status === 201) {
          const data = responseUser.data;
          login(response.data.access, data);
          navigation("/");
        }
      }

      if (response.status !== 200) {
        setErrorOtp(
          response.data?.detail ??
            "Não foi possível validar o código de autenticação.",
        );
        return;
      }
    } catch (error) {
      setErrorOtp(
        error?.response?.data?.detail ??
          "Ocorreu um erro inesperado ao validar o código.",
      );
    } finally {
      setLoadingOtp(false);
    }
  }, [valuesForm, otp, preAuthToken, login, navigation]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && otp.length === 6 && !loading) {
        loginOtp();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [otp, loading, loginOtp]);

  const LoginSistema = async () => {
    const { email, password } = valuesForm;

    if (!email.trim() || !password.trim()) {
      setErrorMsg("Preencha todos os campos.");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      const response = await axios.post(`${urlBase}login/`, valuesForm, {
        validateStatus: (status) => status < 500,
      });

      if (response.status === 428) {
        const { pre_auth_token } = response.data;
        setPreAuthToken(pre_auth_token);
        setOpenModalOtp(true);
        return;
      }

      if (response.status === 200) {
        login(response.data.access, null);
        const responseUser = await userRequest.getUser(response.data.user_id);
        if (responseUser.status === 200 || responseUser.status === 201) {
          const data = responseUser.data;
          login(response.data.access, data);
          navigation("/");
        }
      }

      if (response.status !== 200) {
        setErrorMsg(
          response.data?.detail ?? "Não foi possível realizar o login.",
        );
        return;
      }
    } catch (error) {
      setErrorMsg("Ocorreu um erro inesperado ao realizar o login.");
    } finally {
      setLoading(false);
    }
  };

  const handlePressEnter = (e) => {
    if (e.key === "Enter") {
      LoginSistema();
    }
  };

  const handleClearOtp = () => {
    setOpenModalOtp(false);
    setOtp("");
    setErrorOtp("");
  };

  const requestOtp = useCallback(async () => {
    setLoadingRequestCode(true);

    try {
      const response = await loginRequest.requestToken({
        pre_auth_token: preAuthToken,
      });

      if (response.status === 200) {
        message.success("Enviamos o código OTP para o e-mail cadastrado!");
      }
    } catch (error) {
      const { detail, pre_auth_token } = error.response.data;
      setErrorOtp(detail || pre_auth_token);
    } finally {
      setLoadingRequestCode(false);
    }
  }, [preAuthToken]);

  return (
    <div className="Login">
      <div
        name="normal_login"
        className="login-form"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <img alt="" src={Logo} height={150} />

        <div
          style={{
            marginTop: 20,
            display: "flex",
            flexDirection: "column",
            gap: 8,
            width: "100%",
          }}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Usuario"
            onChange={(e) =>
              setValuesForm((prevState) => ({
                ...prevState,
                email: e.target.value,
              }))
            }
            value={valuesForm.email}
            id="email"
          />

          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Senha"
            onChange={(e) =>
              setValuesForm((prevState) => ({
                ...prevState,
                password: e.target.value,
              }))
            }
            value={valuesForm.password}
            onKeyDown={handlePressEnter}
          />

          {errorMsg && <span style={{ color: "red" }}>{errorMsg}</span>}
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: 16,
            gap: 8,
          }}
        >
          <div style={{ display: "flex" }}>
            <Link className="login-form-forgot" to="/Esqueci-senha">
              Esqueci minha senha
            </Link>
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            onClick={LoginSistema}
            loading={loading}
          >
            Login
          </Button>
        </div>
      </div>

      <ModalOtp
        onCancel={handleClearOtp}
        visible={openModalOtp}
        onChangeOtp={setOtp}
        otp={otp}
        handleConfirm={loginOtp}
        errorMsg={errorOtp}
        loading={loadingOtp}
        handleRequest={requestOtp}
        loadingRequest={loadingRequestCode}
      />
    </div>
  );
};
export default Login;
